<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-button size="mini" plain @click="showCustomerDialog(null,1)"
        v-if="authorities.includes('customer.customers.newcard')">新建会员档案</el-button>
      <el-input size="mini" placeholder="请输入手机号进行搜索"
              v-model="customerRequest.phone"
              @keyup.enter.native="queryCustomerList()"
              style="width: 200px;padding-bottom: 5px"></el-input>
      <el-input size="mini" placeholder="请输入姓名进行搜索"
                v-model="customerRequest.name"
                @keyup.enter.native="queryCustomerList()"
                style="width: 200px;padding-bottom: 5px"></el-input>
      <el-input size="mini" placeholder="请输入刀具号进行搜索"
                v-model="customerRequest.knife"
                @keyup.enter.native="queryCustomerByKnifeText()"
                style="width: 200px;padding-bottom: 5px"></el-input>
      <el-button size="mini" @click="queryCustomerList">查询</el-button>
        <el-table height="510px" :data="customerList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            label="操作"
            fixed="fixed"
            align="center"
            width="100">
            <template slot-scope="scope">
              <el-link icon="iconfont icon-dangan" type="primary" @click="saveNavState(scope.row)"></el-link>
              <el-link icon="el-icon-edit" v-if="authorities.includes('customer.customers.updatecard')" style="margin-left: 10px" size="mini"
                       type="primary"  @click="showCustomerDialog(scope.row,2)"
              ></el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="main"
            label="主/副卡"
            align="center"
            :formatter="mainFormatter"
            width="100">
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="姓名"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="gender"
            label="性别"
            align="center"
            :formatter="ganderFormatter"
            width="60">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机"
            align="center"
            width="120">
          </el-table-column>
          <el-table-column
            prop="totalBalance"
            label="总余额"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="totalGiveBalance"
            label="总赠额"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="cardNum"
            label="总次数"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="customerType"
            label="会员类别"
            align="center"
            :formatter="typeFormatter"
            width="100">
          </el-table-column>
          <el-table-column
            prop="knife"
            label="刀具号"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="registerOrgName"
            label="注册机构"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="注册时间"
            align="center"
            width="180">
          </el-table-column>
          <el-table-column
            prop="customerNo"
            label="档案号"
            align="center"
            width="250">
          </el-table-column>
          <el-table-column
            prop="createName"
            label="建档人"
            align="center"
            width="250">
          </el-table-column>
        </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>

    <!-- 新建会员档案 -->
    <el-dialog
      :title="customerTitle"
      :visible.sync="customerDialogVisible"
      width="60%"
      @close="closeCustomerDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="width: 100%;display: flex; justify-content:space-between">
          <div>
            <div v-if="customer.operateType == 1">
              <label style="color: #FA5858">*</label>
              <span >会员姓名： </span>
              <el-input style="width: 300px"  v-model="customer.customerName" size="mini" />
            </div>
            <div v-if="customer.operateType == 2 && authorities.includes('customer.customers.updatecard.all')">
              <label style="color: #FA5858">*</label>
              <span >会员姓名： </span>
              <el-input style="width: 300px"  v-model="customer.customerName" size="mini" />
            </div>
            <div v-if="customer.operateType == 2 && authorities.includes('customer.customers.updatecard.bufen')">
              <label style="color: #FA5858">*</label>
              <span >会员姓名： </span>
              <el-input style="width: 300px" disabled  v-model="customer.customerName" size="mini" />
            </div>
          </div>
          <div>
            <div v-if="customer.operateType == 1">
              <label style="color: #FA5858">*</label>
              <span>手机：</span>
              <el-input style="width: 300px" @change="checkCustomerPhone" v-model="customer.phone" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')" />
            </div>
            <div v-if="customer.operateType == 2 && authorities.includes('customer.customers.updatecard.all')">
              <label style="color: #FA5858">*</label>
              <span>手机：</span>
              <el-input style="width: 300px" @change="checkCustomerPhone" v-model="customer.phone" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')" />
            </div>
            <div v-if="customer.operateType == 2 && authorities.includes('customer.customers.updatecard.bufen')">
              <label style="color: #FA5858">*</label>
              <span>手机：</span>
              <el-input style="width: 300px" @change="checkCustomerPhone" v-model="customer.phone" size="mini"
                        disabled
                        onkeyup="value=value.replace(/[^\d]/g,'')" />
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top:10px;display: flex; align-items: center; justify-content:space-between">
          <div>
            <label style="color: #ffffff">*</label>
            <span>刀具号码：</span>
            <el-input style="width: 300px" @change="checkCustomerKnife" v-model="customer.knife" size="mini" />
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span >生日：</span>
            <el-date-picker size="mini" style="width: 300px"
                            v-model="customer.birthday"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 5px">
        <div style="width: 100%;">
          <label style="color: #FA5858">*</label>
          <span >性别： </span>
          <el-radio-group style="margin-left: 20px" v-model="customer.gender" @change="changeCustomerGender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </div>
        <div style="width: 100%;margin-top:15px;display: flex;align-items: center">
          <label style="color: #FA5858">*</label>
          <span >会员来源：</span>
          <el-radio-group style="width: 90%" size="mini" v-model="customer.source"  @change="changeCustomerSource">
            <el-radio :label="1">附近居民</el-radio>
            <el-radio :label="2">附近工作</el-radio>
            <el-radio :label="3">偶遇</el-radio>
            <el-radio :label="4">附近办事</el-radio>
            <el-radio :label="5">朋友介绍</el-radio>
            <el-radio :label="6">广告</el-radio>
            <el-radio :label="7">活动卡</el-radio>
            <el-radio :label="8">其他</el-radio>
          </el-radio-group>
        </div>
        <div style="width: 100%;margin-top:15px;display: flex;align-items: center">
          <label style="color: #FA5858">*</label>
          <span >会员职业：</span>
          <el-radio-group style="width: 90%" size="mini" v-model="customer.profession">
            <el-radio :label="1">企业</el-radio>
            <el-radio :label="2">事业单位</el-radio>
            <el-radio :label="3">政府</el-radio>
            <el-radio :label="4">学生</el-radio>
            <el-radio :label="5">无业</el-radio>
            <el-radio :label="6">退休</el-radio>
          </el-radio-group>
        </div>
      </el-card>
      <!-- <el-card class="box-card" style="margin-top: 5px">
        <div style="width: 100%;display: flex;align-items: center">
          <span >足部筛查：</span>
          <el-checkbox-group style="width: 90%" size="mini" v-model="customer.feet">
            <el-checkbox :label="1">脚气</el-checkbox>
            <el-checkbox :label="2">手气</el-checkbox>
            <el-checkbox :label="3">灰指甲</el-checkbox>
            <el-checkbox :label="4">甲沟炎</el-checkbox>
            <el-checkbox :label="5">跖疣</el-checkbox>
            <el-checkbox :label="6">鸡眼</el-checkbox>
            <el-checkbox :label="7">脚垫</el-checkbox>
            <el-checkbox :label="8">干裂</el-checkbox>
            <el-checkbox :label="9">正常</el-checkbox>
            <el-checkbox :label="10">拇外翻</el-checkbox>
            <el-checkbox :label="11">高弓足</el-checkbox>
            <el-checkbox :label="12">扁平足</el-checkbox>
            <el-checkbox :label="13">湿疹</el-checkbox>
            <el-checkbox :label="14">嵌甲</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="width: 100%;margin-top:15px;display: flex;align-items: center">
          <span >既往病史：</span>
          <el-checkbox-group style="width: 90%" size="mini" v-model="customer.pasts">
            <el-checkbox :label="1">糖尿病</el-checkbox>
            <el-checkbox :label="2">高血压</el-checkbox>
            <el-checkbox :label="3">低血糖</el-checkbox>
            <el-checkbox :label="4">心脏病</el-checkbox>
            <el-checkbox :label="5">过敏</el-checkbox>
            <el-checkbox :label="6">晕刀</el-checkbox>
            <el-checkbox :label="7">晕血</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-card> -->
      <el-card class="box-card" style="margin-top: 5px" v-if="isShowRelevanceButton">
        <div v-if="isShowRelevanceButton" style="width: 100%;display: flex; align-items: center">
          <span v-if="customer.main === 1">关联副卡：</span>
          <span v-if="multipleSelection.length > 0" style="margin-left: 5px;" v-for="(item,index) in multipleSelection" :key="index">
            {{item.customerName}}、
          </span>
          <el-button size="mini" v-if="customer.main === 1" style="margin-left: 10px" plain
                     :disabled="this.multipleSelection.length === 3"
                     @click="showCustomerListDialog">绑定副卡</el-button>
          <el-button size="mini" v-if="customer.main === 1" :disabled="multipleSelection.length === 0" style="margin-left: 10px" plain @click="showBangCustomer">解除副卡</el-button>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeCustomerDialog">取 消</el-button>
        <el-button size="mini" @click="createCustomer">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="解绑副卡"
      :visible.sync="bangCustomerDialogVisible"
      width="50%"
      @close="closeBangCustomerDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="multipleSelection" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          align="center"
          label="操作" width="100">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-delete"
                     @click="deleteCustomerShowList(scope.$index,scope.row, multipleSelection)"></el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="会员名" width="300">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机" width="277">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeBangCustomerDialog">取 消</el-button>
        <el-button size="mini" type="primary" @click="deleteBangCustomer">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择会员 -->
    <el-drawer
      title="会员列表"
      size="450px"
      :visible.sync="selectCustomerDialogVisible"
      :before-close="handleClose"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-input size="mini"
                placeholder="输入手机号进行过滤" v-model="customerRequest.queryText"
                @keyup.enter.native="queryCustomerByPhone()">
      </el-input>
      <el-table :data="noMainCustomerList" fit border stripe="stripe" width="100%"  size="mini"
                ref="multipleTable"
                highlight-current-row
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                @select="handleSelectionChange">
        <el-table-column
          align="center"
          type="selection"
          width="110">
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="会员名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentPage1"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal1">
        </el-pagination>
      </div>
    </el-drawer>

    <el-dialog
      title="验证码"
      :visible.sync="bindCheckCodeVisibleDialog"
      width="20%"
      @close="closeBindCheckCodeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#003c76;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;width: 100%;align-items: center">
        <span style="width: 20%">验证码</span>
        <el-input v-model="customer.checkCode" style="width: 70%" size="mini"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeBindCheckCodeDialog">取 消</el-button>
        <el-button size="mini" type="primary" @click="sendCheckCode">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      authorities:'',
      customerList:[],
      noMainCustomerList:[],
      queryText:'',
      queryKnifeText:'',
      activePath:'',
      bindCheckCode:'', //绑定副卡时的短信验证码
      mainText:[
        {main:1,name:'主卡'},
        {main:2,name:'副卡'}
      ],
      isGanderText:[
        {gender:1,name:'男'},
        {gender:2,name:'女'}
      ],
      isLevelText:[
        {level:1,name:'钻石会员'},
        {level:2,name:'铂金会员'},
        {level:3,name:'黄金会员'},
        {level:4,name:'大众会员'}
      ],
      isTypeText:[
        {customerType:1,name:'储值类'},
        {customerType:2,name:'康复类'},
        {customerType:3,name:'非储值类'}
      ],
      customerDialogVisible:false,
      customerTitle:'',
      customer:{
        id:'',
        customerName:'',
        gender:'',
        phone:'',
        birthday:'',
        age:'',
        systemFileNo:'',
        pageFileNo:'',
        knife:'',
        source:'',
        profession:'',
        customerType:'',
        feet:[],
        pasts:[],
        childCustomers:'',
        creator:'',
        level:'',
        registerOrgId:'',
        registerOrgName:'',
        operateType:'',
        relevanceCustomers:[],
        totalBalance:'',
        giveBalance: '',
        balance:'',
        main:'',
        checkCode:'',
        //默认不需要验证吗
        isValidaCheckCode:2,
        deleteBindCustomer:[],
        createName:''
      },
      selectCustomerDialogVisible:false,
      multipleSelection:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,
      isShowRelevanceButton:false,
      bangCustomerDialogVisible:false,
      phoneExist:false,
      knifeExist:false,

      bindCheckCodeVisibleDialog:false,
      isBindCustomer:false,
      createCustomerDoubleClick:false,
      customerRequest:{
        pageNum: '',
        pageSize: '',
        name: '',
        phone:'',
        orgId:'',
        knife:'',
        queryText:''
      }
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    // this.init();
  },
  methods:{
    // async init(){
    //   const {data:res} = await this.$http.get(`/init/customers/${this.orgId}`)
    //   this.customerList = res.data;
    //   this.pageTotal = res.totalPage;
    // },
    showBindCheckCodeDialog(){
      this.bindCheckCodeVisibleDialog = true;
    },
    closeBindCheckCodeDialog(){
      this.bindCheckCodeVisibleDialog = false;
    },
    showBangCustomer(){
      this.bangCustomerDialogVisible = true;
      this.customer.deleteBindCustomer = [];
    },
    closeBangCustomerDialog(){
      this.loadCustomerDetail();
      this.bangCustomerDialogVisible = false;
    },
    deleteCustomerShowList(index,row,rows){
      this.customer.deleteBindCustomer.push(row);
      rows.splice(index, 1);
    },
    async deleteBangCustomer(){
      const {data:res} = await this.$http.post(`/customer/jiebang/customerId/${this.customer.id}
        /orgName/${this.customer.registerOrgName}/customerName/${this.customer.customerName}/creator/${this.userId}`,
        this.customer.deleteBindCustomer);
      if (res.code === 200){
        this.$message.success("操作成功！");
        await this.loadCustomerDetail();
      }

      this.closeBangCustomerDialog();
    },
    queryCustomerByKnifeText(){
      this.queryCustomerByKnifeCount();
      this.queryCustomerByKnife();
    },
    async queryCustomerByKnifeCount(){
      const {data:res} = await this.$http.post(`/query/knife/count/customers`, this.customerRequest)
      this.pageTotal = res.totalPage;
    },
    async queryCustomerByKnife(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.orgId;
      const {data:res} = await this.$http.post(`/query/knife/customers`, this.customerRequest)
      this.customerList = res.data;
    },
    queryCustomerList(){
      this.currentPage = 1
      if (this.customerRequest.knife !== '' ){
        this.queryCustomerByKnifeText();
      } else if (this.customerRequest.name === '' && this.customerRequest.phone === '' && this.customerRequest.knife === ''){
          this.init();
      } else {
        this.loadCustomerCount();
        this.loadCustomers();
      }
    },
    async loadCustomerCount(){
      const {data:res} = await this.$http.post(`/query/customers/count`, this.customerRequest)
      if (res.code !== 200){
        return this.$message.error("获取会员列表失败！")
      }
      this.pageTotal = res.totalPage;
    },
    async loadCustomers(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.orgId;
      const {data:res} = await this.$http.post(`/query/customers`, this.customerRequest)
      if (res.code !== 200){
        return this.$message.error("获取会员列表失败！")
      }
      this.customerList = res.data;
    },
    async loadNoMainCustomers(){
      this.customerRequest.pageNum = this.currentPage1;
      this.customerRequest.pageSize = this.pageSize1;
      this.customerRequest.orgId = this.orgId;
      const {data:res} = await this.$http.post(`/query/customers/no/balance`, this.customerRequest)
      this.noMainCustomerList = res.data;
    },
    toDetail(item){
      this.$router.push({path:'/card',query:{id:item.relevanceCustomerId}});
    },
    ganderFormatter(row){
      let value = "";
      for (let i = 0; i < this.isGanderText.length; i++){
        let item = this.isGanderText[i];
        if (row.gender === item.gender) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    mainFormatter(row){
      let value = "";
      for (let i = 0; i < this.mainText.length; i++){
        let item = this.mainText[i];
        if (row.main === item.main) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    dataFormatter(row,column){
      let data = row[column.property];
      if(data === null){
        return null;
      }
      let dt = new Date(data);
      return dt.getFullYear() + '-' + (dt.getMonth()+1) + '-' + dt.getDate();
    },
    levelFormatter(row) {
      let value = "";
      for (let i = 0; i < this.isLevelText.length; i++) {
        let item = this.isLevelText[i];
        if (row.level === item.level) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    typeFormatter(row) {
      let value = "";
      for (let i = 0; i < this.isTypeText.length; i++) {
        let item = this.isTypeText[i];
        if (row.customerType === item.customerType) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    saveNavState(row){
      this.$router.push({path:'/card',query:{id:row.id}});
    },
    async showCustomerDialog(data, value){
      this.customer.operateType = value;
      if (value === 1){
        this.customerTitle = '新建会员档案';
        this.isShowRelevanceButton = false;
        this.customer.customerName = '';
        this.customer.birthday = '';
        this.customer.gender = '';
        this.customer.childCustomers = null;
        this.customer.phone = '';
        this.customer.age = '';
        this.customer.knife = '';
        this.customer.feet = [];
        this.customer.pasts = [];
        this.customer.source = '';
        this.customer.profession = '';
        this.customer.multipleSelection = [];
      }
      if (value === 2){
        this.customerTitle = '编辑会员档案';
        this.isShowRelevanceButton = true;
        this.customer.id = data.id;
        await this.loadCustomerDetail();
      }
      this.customerDialogVisible = true;
    },
    async loadCustomerDetail(){
      const {data:res} = await this.$http.get(`/customer/customerId/${this.customer.id}/orgId/${this.orgId}`)
      this.customer.id = res.data.id;
      this.customer.customerName = res.data.customerName;
      this.customer.birthday = res.data.birthday;
      this.customer.gender = res.data.gender;
      this.customer.childCustomers = res.data.childCustomers;
      this.customer.phone = res.data.phone;
      this.customer.age = res.data.age;
      this.customer.knife = res.data.knife;
      this.customer.feet = res.data.feet;
      this.customer.pasts = res.data.pasts;
      this.customer.source = res.data.source;
      this.customer.profession = res.data.profession;
      this.customer.totalBalance = res.data.totalBalance;
      this.customer.giveBalance = res.data.giveBalance;
      this.customer.balance = res.data.balance;
      this.customer.main = res.data.main;
      this.customer.registerOrgName = res.data.registerOrgName;
      this.multipleSelection = res.data.relevanceCustomers;
    },
    toggleSelection(){
      this.$nextTick(function () {
        this.multipleSelection.map((rows) => {
          this.customerList.map((row,index) => {
            if(rows.id === row.id ){
              this.$refs.multipleTable.toggleRowSelection(this.customerList[index],true)
            }
          })
        });
      })
    },
    closeCustomerDialog(){
      this.customerDialogVisible = false;
    },
    changeCustomerGender(value){
      this.customer.gender = value;
    },
    showCustomerListDialog(){
      this.noMainCustomerList = [];
      this.pageTotal1 = 0;
      this.selectCustomerDialogVisible = true;
    },
    async queryCustomerByPhone(){
      await this.loadNoMainCustomerCount();
      await this.loadNoMainCustomers();
    },
    async loadNoMainCustomerCount(){
      const {data:res} = await this.$http.post(`/query/customers/no/balance/count`, this.customerRequest)
      this.pageTotal1 = res.totalPage;
    },
    handleClose(){
      this.customerRequest.queryText = '';
      this.selectCustomerDialogVisible = false;
    },
    handleSelectionChange(val,row) {
      let existLength = this.multipleSelection.length;
      if(this.multipleSelection.includes(row)){
        existLength = this.multipleSelection.length - 1;
      }
      if (existLength >= 3){
        return this.$message.warning("最多只能选择3个副卡！");
      }
      if (this.multipleSelection.length === 0){
        this.multipleSelection.push(row);
        this.isBindCustomer = true;
      } else {
        let result = false;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].id !== row.id){
            result = true;
            this.isBindCustomer = true;
          }
          if (this.multipleSelection[i].id === row.id){
            result = false;
            this.multipleSelection.splice(i,1);
            this.isBindCustomer = false;
          }
        }
        if (result){
          this.multipleSelection.push(row);
        }
      }
      this.customer.relevanceCustomers = this.multipleSelection;
    },
    async createCustomer(){
      if (this.customer.customerName === ''){
        return this.$message.warning("请填写会员姓名！");
      }
      if (this.customer.phone === ''){
        return this.$message.warning("请填写手机！");
      }
      if (this.customer.phone.length > 11){
        return this.$message.warning("请正确填写手机！");
      }
      if (this.customer.birthday === ''){
        return this.$message.warning("请填写生日！");
      }
      if (this.customer.gender === ''){
        return this.$message.warning("请填写性别！");
      }
      if (this.customer.source === ''){
        return this.$message.warning("请填写来源！");
      }
      if (this.customer.profession === ''){
        return this.$message.warning("请填写职业！");
      }
      if (this.phoneExist){
        return this.$message.warning("该手机号已经存在！");
      }
      if (this.knifeExist){
        return this.$message.warning("该刀具号已经存在！");
      }

      this.customer.creator = this.userId;
      this.customer.createName = this.userName;
      this.customer.level = 0;
      this.customer.registerOrgId = this.orgId;
      this.customer.childCustomers = this.multipleSelection;

      //表示绑定了会员，需要提交验证码
      if (this.isBindCustomer){
          this.customer.isValidaCheckCode = 1;
          await this.getCheckCode();
          this.showBindCheckCodeDialog();
          return;
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/customer`, this.customer)
      if (res.code !== 200){
        this.$message.error("创建会员失败！")
      }
      if (res.code === 200){
        if (this.customer.operateType === 1){
          this.$message.success("创建会员成功！")
          let customerId = res.data;
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          await this.$router.push({path: '/card', query: {id:customerId}});
        }
        if (this.customer.operateType === 2){
          this.$message.success("更新会员成功！")
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        }
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.isBindCustomer = false;
      await this.loadCustomers();
      this.closeCustomerDialog();
    },
    async checkCustomerPhone(){
      const {data:res} = await this.$http.get(`/customer/check/phone/${this.customer.phone}`);
      if (res.data > 0){
        this.phoneExist = true;
        this.$message.warning("该手机号已经存在！")
      } else {
        this.phoneExist = false;
      }
    },
    async checkCustomerKnife(){
      const {data:res} = await this.$http.get(`/customer/check/knife/${this.customer.knife}/orgId/${this.orgId}`);
      if (res.data > 0){
        this.knifeExist = true;
        this.$message.warning("该刀具号已经存在！")
      } else {
        this.knifeExist = false;
      }
    },
    changeCustomerSource(){
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadCustomers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCustomers();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadNoMainCustomers();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadNoMainCustomers();
    },
    async getCheckCode(){
      const {data:res} = await this.$http.get(`/bind/customer/get/code/${this.customer.phone}`);
      if (res.code === 200) {
        return this.$message.success("验证码已发送至此会员手机，请注意查收！")
      } else {
        return this.$message.error("操作失败！")
      }
    },
    async sendCheckCode(){
      const {data:res} = await this.$http.post(`/customer`, this.customer)
      if (res.code === 200){
        if (this.operateType === 1){
          this.$message.success("创建会员成功！")
        }
        if (this.operateType === 2){
          this.$message.success("更新会员成功！")
        }
      }
      await this.loadCustomers();
      this.closeBindCheckCodeDialog();
      this.closeCustomerDialog();
    }
  }
}
</script>

<style lang="less" scoped>

/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue